<template>
    <div>
        <footer
            class="fixed inset-x-0 bottom-0 px-2 pt-2 pb-4 bg-highlight-5 border-t-2 border-highlight-10 transform transition duration-100 ease-in"
            :class="[ scrolled ? 'translate-y-full' : 'translate-y-0' ]"
        >
            <p class="text-xxs text-center leading-tight text-highlight-60">
                <slot></slot>
                <span class="block mt-1">
                    <a class="underline text-highlight-80" :href="termsUrl">{{ _('terms_conditions') }}</a> |
                    <a class="underline text-highlight-80" :href="privacyUrl">{{ _('terms_privacy') }}</a>
                </span>
            </p>
        </footer>
        <footer class="pt-4" v-if="scrolled">
            <p class="text-xxs text-center leading-tight text-highlight-60">
                <slot></slot>
                <span class="block mt-1">
                    <a class="underline text-highlight-80" :href="termsUrl">{{ _('terms_conditions') }}</a> |
                    <a class="underline text-highlight-80" :href="privacyUrl">{{ _('terms_privacy') }}</a>
                </span>
            </p>
        </footer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            _: 'localisation/translate',
        }),
    },
    data() {
        return {
            scrolled: false,
            termsUrl: process.env.VUE_APP_TERMS_URL,
            privacyUrl: process.env.VUE_APP_PRIVACY_URL,
        }
    },
    created() {
        this.scrolled = window.scrollY > 50
        const handleScroll = () => {
            this.scrolled = window.scrollY > 50
        }
        window.addEventListener('scroll', handleScroll)
        this.$once('hook:destroyed', () => {
            // eslint-disable-next-line no-restricted-globals
            removeEventListener('scroll', handleScroll)
        })
    },
}
</script>
